/**
 * From filter on rest format to the one expected by FixedFilters component
 *
 * @param filterRest
 * @returns
 *
 * @example
 *
 * const filter = getCleanFilterComp("6051ecf9544f8a0013ffd127,6051ecf9544f8a0013ffd12b");
 * // ['6051ecf9544f8a0013ffd127', '6051ecf9544f8a0013ffd12b']
 *
 * const filterWithExclusion = getCleanFilterComp("!=6051ecf9544f8a0013ffd127");
 * // ['all', '6051ecf9544f8a0013ffd127']
 */
const getCleanFilterComp = (filterRest: string) => {
  if (!filterRest) {
    return ['all'];
  }
  const result = [];
  if (filterRest.indexOf('!=') === 0) {
    result.push('all');
  }
  return result.concat(filterRest.replace(/!=/, '').split(','));
};

export default getCleanFilterComp;
